import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
// import { FaCheckCircle, FaRegThumbsUp } from "react-icons/fa";
import { Row, Col, Button } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

// Setup the localizer by providing the moment object to the localizer function
const localizer = momentLocalizer(moment);

console.log("localizerlocalizerlocalizer", localizer);

const TwoMonthCalendar = ({ events, onDateSelect }) => {
  const [processedEvents, setProcessedEvents] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [currentDate, setCurrentDate] = useState(new Date());
  console.log(events, "eventseventsevents");
  const eventStyleGetter = (event, start, end, isSelected) => {
    const style = {
      backgroundColor: event.color, // Use the color property from the event
      borderRadius: "5px",
      color: "white",
      border: "none",
      display: "block", // Make all events visible
      cursor: "pointer",
    };

    return {
      style,
    };
  };

  // Check if a date is disabled (booked, locked, or in the past)
  const isDateDisabled = (date) => {
    if (!processedEvents) return false;

    // Check if date is in the past (before today)
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (date < today) {
      return true; // Disable past dates
    }

    // Check if date is booked or locked
    return processedEvents.some(event => {
      const eventStart = new Date(event.start);
      const eventEnd = new Date(event.end);
      return date >= eventStart && date <= eventEnd;
    });
  };

  // Handle date selection - simplified to only allow single date selection
  const handleDateSelect = (slotInfo) => {
    const clickedDate = new Date(slotInfo.start);
    clickedDate.setHours(0, 0, 0, 0);

    // Check if date is in the past, already booked, or locked
    if (isDateDisabled(clickedDate)) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (clickedDate < today) {
        console.log("Cannot select dates in the past");
      } else {
        console.log("This date is not available - already booked or locked");
      }
      return;
    }

    // Single date selection
    setSelectedDate(clickedDate);
    if (onDateSelect) onDateSelect(clickedDate);
  };

  // Navigate between months
  const navigateCalendar = (direction) => {
    const newDate = new Date(currentDate);
    newDate.setMonth(currentDate.getMonth() + direction);
    setCurrentDate(newDate);
  };
  useEffect(() => {
    if (events) {
      const processedEvents = events?.map((event) => {
        // Create a new date object to avoid modifying the original
        const startDate = moment(event.start).startOf("day");
        let endDate;

        // If overnight is defined and greater than 0, add 1 day to ensure correct display
        if (event.overNight && parseInt(event.overNight) > 0) {
          // Set end date to be exactly the right number of days
          // This is startDate + overnight days
          endDate = moment(startDate)
            .add(parseInt(event.overNight), "days")
            .endOf("day");
        } else {
          // For non-overnight events, just use the end date as is
          endDate = moment(event.end).endOf("day");
        }

        return {
          ...event,
          start: startDate.toDate(),
          end: endDate.toDate(),
          moreCount: undefined,
          moreCountZ: undefined,
        };
      });

      setProcessedEvents(processedEvents);
    }
  }, [events]);
  console.log(events, "events");
  return (
    <>
      <div className="calendar-navigation mb-2">
        {/* <Button variant="outline-secondary" onClick={() => navigateCalendar(-1)} className="me-2">
          Previous Month
        </Button>
        <h5 className="d-inline-block mb-0 mx-2">
          {moment(currentDate).format('MMMM YYYY')}
        </h5>
        <Button variant="outline-secondary" onClick={() => navigateCalendar(1)} className="ms-2">
          Next Month
        </Button> */}
      </div>

      <div className="calendar-legend mb-2 d-flex justify-content-left">
        <div className="legend-item me-3">
          <span className="legend-color" style={{ backgroundColor: 'red', width: '15px', height: '15px', display: 'inline-block', marginRight: '5px' }}></span>
          Booked
        </div>
        <div className="legend-item me-3">
          <span className="legend-color" style={{ backgroundColor: 'orange', width: '15px', height: '15px', display: 'inline-block', marginRight: '5px' }}></span>
          Locked by Owner
        </div>
        <div className="legend-item me-3">
          <span className="legend-color" style={{ backgroundColor: '#007bff', width: '15px', height: '15px', display: 'inline-block', marginRight: '5px' }}></span>
          Selected Date
        </div>
        <div className="legend-item">
          <span className="legend-color" style={{ backgroundColor: '#4CAF50', width: '15px', height: '15px', display: 'inline-block', marginRight: '5px' }}></span>
          Today
        </div>
      </div>

      <Row className="single-listing-calendar">
        <Col>
          <Calendar
            localizer={localizer}
            events={processedEvents}
            views={["month"]}
            defaultView="month"
            startAccessor="start"
            endAccessor="end"
            date={currentDate}
            onNavigate={(date) => setCurrentDate(date)}
            selectable={true}
            onSelectSlot={handleDateSelect}
            eventPropGetter={eventStyleGetter}
            messages={{
              showMore: () => "",
            }}
            style={{ height: "500px" }}
            components={{
              event: ({ event }) => (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id={`tooltip-${event.id}`}>{event.title} - {moment(event.start).format('MMM DD')} to {moment(event.end).format('MMM DD')}</Tooltip>}
                >
                  <div
                    style={{
                      backgroundColor: event.color,
                      padding: 0,
                      borderRadius: 0,
                      color: "#fff",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      display: "block",
                    }}
                  >
                    {event.title}
                  </div>
                </OverlayTrigger>
              ),
              dateCellWrapper: ({ value, children }) => {
                // Add custom styling for selected dates
                const date = new Date(value);
                date.setHours(0, 0, 0, 0);

                const today = new Date();
                today.setHours(0, 0, 0, 0);
                const isToday = date.getTime() === today.getTime();

                const isPast = date < today;

                const isSelected = selectedDate &&
                  date.getTime() === selectedDate.getTime();

                let className = '';
                if (isSelected) className = 'selected-date';
                if (isToday) className += ' today-date';
                if (isPast) className += ' past-date';

                return (
                  <div className={`rbc-day-bg ${className}`} style={{
                    position: 'relative',
                    backgroundColor: isToday
                      ? 'rgba(76, 175, 80, 0.2)' // Light green for today
                      : isSelected
                        ? 'rgba(0, 123, 255, 0.1)' // Light blue for selected date
                        : isPast
                          ? 'rgba(200, 200, 200, 0.3)' // Light gray for past dates
                          : '',
                    border: isToday
                      ? '2px solid #4CAF50' // Green border for today
                      : isSelected
                        ? '2px solid #007bff' // Blue border for selected date
                        : '',
                    opacity: isPast ? 0.7 : 1, // Reduce opacity for past dates
                    cursor: isPast ? 'not-allowed' : 'pointer' // Show not-allowed cursor for past dates
                  }}>
                    {children}
                  </div>
                );
              }
            }}
          />
        </Col>
      </Row>

      {selectedDate && (
        <div className="selected-date-info mt-3 text-center">
          <p className="mb-1">
            <strong>Selected Date:</strong> {moment(selectedDate).format('MMMM DD, YYYY')}
          </p>
        </div>
      )}
    </>
  );
};

export default TwoMonthCalendar;
